import { Button, Input, message, Upload, UploadProps } from "antd";
import React, { useCallback, useEffect, useState, useRef } from "react";
import "../../../../../styles/StayUptoDateCSS/StayUpToDateControls.css";
import { supabase } from "../../../../../config/supabaseClient";
import { StaticCompnents } from "../../../../../Utils/StaticComponent";
import { handleProductFileUpload } from "../../../../../Utils/uploadImage/UploadImage";
import { debounce } from "lodash";

const HighlightLinksComponents = (props: any) => {
  const {
    username,
    user_id,
    defaultName,
    link,
    image,
    defaultFileList,
    cta,
    view,
    setView,
    errorMsg,
    isUploading,
    setIsUploading,
    setErrorMsg,
  } = props;
  const [name, setName] = useState("");
  const [shoplink, setShoplink] = useState("");
  const [fileList, setFileList] = useState<any[]>([]);
  const [shopImage, setShopImage] = useState("");
  const [shopCTA, setShopCTA] = useState("");
  const [errorInputMsg, setErrorInputMsg] = useState({
    buttonErrorMsg: "",
    titleErrorMsg: "",
  });

  // Use a ref to track if this is the initial render
  const isInitialMount = useRef(true);
  // Use a ref to track the last uploaded image URL
  const lastImageRef = useRef("");

  const { LeftViewIcon } = StaticCompnents();

  // Initialize form data from props
  useEffect(() => {
    setName(defaultName);
    setShoplink(link);
    setFileList(defaultFileList);
    setShopCTA(cta);
    setShopImage(image);

    // If there's an image in props, update the ref
    if (image) {
      lastImageRef.current = image;
    }
  }, [defaultName, link, cta, image]);

  // Handle data updates to parent, but separate from image changes
  useEffect(() => {
    // Skip on initial mount
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    // Use the ref value to ensure the image persists
    const currentImage = shopImage || lastImageRef.current;

    props.handleData(currentImage, name, shoplink, "link", shopCTA);
  }, [name, shoplink, shopCTA]); // Removed shopImage from dependencies

  // Separate effect specifically for image changes
  useEffect(() => {
    // Only update when shopImage changes and is not empty
    if (shopImage && shopImage !== lastImageRef.current) {
      lastImageRef.current = shopImage;
      props.handleData(shopImage, name, shoplink, "link", shopCTA);
    }
  }, [shopImage]);

  const handleInputChange = (
    value: string,
    setter: React.Dispatch<React.SetStateAction<string>>,
    limit: number
  ) => {
    if (limit && value.length <= limit) {
      limit === 15
        ? setErrorInputMsg({ ...errorInputMsg, buttonErrorMsg: "" })
        : setErrorInputMsg({ ...errorInputMsg, titleErrorMsg: "" });
      setter(value);
      limit === 15 ? props.setCTA(value) : props.setName(value);
      setErrorMsg("");
    } else {
      limit === 15
        ? setErrorInputMsg({
            ...errorInputMsg,
            buttonErrorMsg: `Button Text is limited to ${limit} characters.`,
          })
        : setErrorInputMsg({
            ...errorInputMsg,
            titleErrorMsg: `Highlight Title is limited to ${limit} characters.`,
          });
    }
  };

  const debouncedUpload = useCallback(
    debounce(async (info) => {
      const { file } = info;

      // Prevent multiple uploads
      if (isUploading) {
        return;
      }

      // Set uploading flag
      setIsUploading(true);
      setErrorMsg("Please wait till the highlight upload");

      try {
        const result = await handleProductFileUpload({
          info,
          username,
          productName: "",
          setFileList,
          setProductImage: setShopImage,
          storageName: "highlight_section",
        });

        // Update our ref with the new image URL
        if (result && result.publicUrl) {
          lastImageRef.current = result.publicUrl;
        }
      } finally {
        setIsUploading(false);
        setErrorMsg("");
      }
    }, 300),
    [isUploading, username, supabase]
  );

  const uploadProps: UploadProps = {
    name: "file",
    multiple: false,
    maxCount: 1,
    accept: "image/*",
    async onChange(info) {
      setFileList([...info.fileList]);
      debouncedUpload(info);
    },
  };

  const beforeUpload = (file: any) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("You can only upload image files!");
    }
    return isImage || Upload.LIST_IGNORE; // Prevent uploading non-image files
  };

  useEffect(() => {
    let buttonErrorTimer: NodeJS.Timeout;
    let titleErrorTimer: NodeJS.Timeout;

    if (errorInputMsg.buttonErrorMsg) {
      buttonErrorTimer = setTimeout(() => {
        setErrorInputMsg((prev) => ({ ...prev, buttonErrorMsg: "" }));
      }, 10000);
    }

    if (errorInputMsg.titleErrorMsg) {
      titleErrorTimer = setTimeout(() => {
        setErrorInputMsg((prev) => ({ ...prev, titleErrorMsg: "" }));
      }, 10000);
    }

    return () => {
      clearTimeout(buttonErrorTimer);
      clearTimeout(titleErrorTimer);
    };
  }, [errorInputMsg]);

  return (
    <div>
      {" "}
      {/* <p>Preview</p> */}
      {/* <h6 className="mb-15">
        Create a custom shop links highlight{" "}
      </h6> */}
      <div
        className="highlight-data-section mb-2"
        style={view === "right" ? { flexDirection: "row-reverse" } : {}}
      >
        <div
          className="highlight-media"
          style={
            view === "right"
              ? { marginLeft: "3%", marginRight: "0" }
              : { marginRight: "3%" }
          }
        >
          <img
            src={shopImage || lastImageRef.current || "/assets/image-bg.jpeg"}
            className="shop-image"
            // src={component?.details?.split(",")[0]}
          />
        </div>

        <div className="highlight-details">
          <div className="highlight-name">
            {name ? name : "Highlight Title"}
          </div>
          <div className="highlight-link-tag">
            {shopCTA && (
              <Button className="highlight-shop-button" id="highlight-add">
                {shopCTA}
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className="fieldGroup">
        <label className="bold-label fontsize-12">Highlight Title</label>
        <Input
          placeholder="Enter Title"
          value={name}
          onChange={(e: any) => {
            handleInputChange(e.target.value, setName, 150);
            // props.setErrorMsg("");
          }}
          className="mb-15"
          id="highlight-title"
        />
        {errorInputMsg && errorInputMsg.titleErrorMsg && (
          <p className="errorMsg">{errorInputMsg.titleErrorMsg}</p>
        )}
        <label className="bold-label fontsize-12">Button Text</label>
        <Input
          placeholder="Enter Button Text"
          value={shopCTA}
          onChange={(e: any) => {
            handleInputChange(e.target.value, setShopCTA, 15);
          }}
          className="mb-15"
          id="highlight-button"
        />
        {errorInputMsg && errorInputMsg.buttonErrorMsg && (
          <p className="errorMsg">{errorInputMsg.buttonErrorMsg}</p>
        )}
        <label className="bold-label fontsize-12">Button Link</label>
        <Input
          placeholder="www.yourlink.com"
          value={shoplink}
          onChange={(e: any) => setShoplink(e.target.value)}
          className="mb-15"
          id="highlight-link"
        />
       
        <label className="bold-label fontsize-12">Image</label>
        <div className="image-upload-section mb-15" >
          <Upload
            accept="image/*"
            {...uploadProps}
            multiple={false}
            maxCount={1}
            // progress={}
            beforeUpload={beforeUpload}
            showUploadList={
              fileList.length === 0 ? false : { showRemoveIcon: false }
            }
          >
            <Button className="uploadButton" id="highlight-image">
              <div className="text-center">
                <p className="textContainerHeading">
                  Click to select image or drag & drop to this area to upload
                </p>
                <p className="upload-text break-word">
                  JPG, JPEG, PNG, HEIC, or WEBP
                </p>
                <i
                  className="upload-text break-word"
                  style={{ marginTop: "4px", color: "#666" }}
                >
                  Please upload an image with a resolution of 300px height &
                  300px width
                </i>
              </div>
              {/* Click to Upload */}
            </Button>
          </Upload>
        </div>
        {(shopImage || lastImageRef.current) && (
          <>
            <label className="bold-label fontsize-12" style={{marginTop:"15px"}}>Presentation</label>
            <div className="link-presentation-highlight mt-15">
              <span
                className={view == "left" ? "active" : ""}
                onClick={() => setView("left")}
              >
                <LeftViewIcon className="links-view-icon" />
              </span>
              <span
                className={
                  view == "right" ? "active right-view-icon" : "right-view-icon"
                }
                onClick={() => setView("right")}
              >
                <LeftViewIcon className="links-view-icon" />
              </span>
            </div>
          </>
        )}
      </div>
      {errorMsg && <p className="errorMsg">{errorMsg}</p>}
    </div>
  );
};

export default HighlightLinksComponents;
